import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { logout, setMe } from '../redux/actions/auth.action';
import { setLoading } from '../redux/actions/loader.action';
import axios from 'axios';
import { endpointApi } from '../utils';

export default function Header() {
  const jwt_access = localStorage.getItem('jwt_access');
  const date = new Date();
  const profileRef = useRef(null);
  const settingsRef = useRef(null);
  const dropdownRef = useRef(null);
  const { me } = useSelector(state => state.auth);

  const [q, setQ] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [URLSearchParams] = useSearchParams();
  const _q = URLSearchParams.get('q');
  const [activMenu, setActivMenu] = useState(null);
  const [modal, setModal] = useState(null);
  
  const [user, setUser] = useState(null);
  
  const [successMessage, setSuccessMessage] = useState(null);
  const [gender, setGender] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phone, setPhone] = useState("");
  const [job, setJob] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [isGenderTouched, setIsGenderTouched] = useState(false);
  const [isFirstnameTouched, setIsFirstnameTouched] = useState(false);
  const [isLastnameTouched, setIsLastnameTouched] = useState(false);
  const [isPhoneTouched, setIsPhoneTouched] = useState(false);
  const [isJobTouched, setIsJobTouched] = useState(false);
  const [isEmailTouched, setIsEmailTouched] = useState(false);
  const [isPasswordTouched, setIsPasswordTouched] = useState(false);
  const [isCurrentPasswordTouched, setIsCurrentPasswordTouched] = useState(false);
  const [errors, setErrors] = useState(null);

  useEffect(() => {
    setUser(me);
  }, [me]);

  useEffect(() => {
    if(user && modal){
      setGender(user.gender);
      setLastname(user.last_name);
      setFirstname(user.first_name);
      setPhone(user.phone ? user.phone : '');
      setJob(user.job ? user.job : '');
      setEmail(user.email);
    }else{
      setGender("");
      setFirstname("");
      setLastname("");
      setPhone("");
      setJob("");
      setEmail("");
    }
    
    if(modal === null)
      setSuccessMessage(null);

    setCurrentPassword("");
    setPassword("");
    setIsGenderTouched(false);
    setIsFirstnameTouched(false);
    setIsLastnameTouched(false);
    setIsPhoneTouched(false);
    setIsJobTouched(false);
    setIsEmailTouched(false);
    setIsPasswordTouched(false);
    setIsCurrentPasswordTouched(false);
  }, [user, modal]);

  useEffect(() => {
    setQ(_q ? _q : "");
  }, [location, _q]);

  const search = (e) => {
    e.preventDefault();
    let url = "/orders";
    const { pathname } = location;

    if(pathname !== "/"){
      if(/^\/users.*/.test(pathname)){
        url = "/users";
      }else if(/^\/employees.*/.test(pathname)){
        url = "/employees";
      }else if(/^\/raw-materials\/rambos.*/.test(pathname)){
        url = "/raw-materials/rambos";
      }else if(/^\/raw-materials\/bambous.*/.test(pathname)){
        url = "/raw-materials/bambous";
      }else if(/^\/categories.*/.test(pathname)){
        url = "/categories";
      }else if(/^\/products.*/.test(pathname)){
        url = "/products";
      }else if(/^\/packagings\/history.*/.test(pathname)){
        url = "/packagings/history";
      }else if(/^\/packagings.*/.test(pathname)){
        url = "/packagings";
      }else if(/^\/suppliers.*/.test(pathname)){
        url = "/suppliers";
      }else if(/^\/orders.*/.test(pathname)){
        url = "/orders";
      }else if(/^\/clients.*/.test(pathname)){
        url = "/clients";
      }else if(/^\/delivry-notes.*/.test(pathname)){
        url = "/delivry-notes";
      }else if(/^\/proforma-invoices.*/.test(pathname)){
        url = "/proforma-invoices";
      }else if(/^\/invoices.*/.test(pathname)){
        url = "/invoices";
      }else if(/^\/expenses.*/.test(pathname)){
        url = "/expenses";
      }else if(/^\/tasks\/rambos.*/.test(pathname)){
        url = "/tasks/rambos";
      }else if(/^\/tasks\/bambous.*/.test(pathname)){
        url = "/tasks/bambous";
      }
    }

    if(q.length > 1){
      URLSearchParams.set('q', q);
      URLSearchParams.delete('page');
      const search = URLSearchParams.toString();
      
      if(search.length > 0)
        url += "?" + search;
      navigate(url);
    }
  }

  useEffect(() => {
    const clickOutsideModal = (e) => {
      if(profileRef.current === e.target || settingsRef.current === e.target || e.target.classList.contains('_modal-close')){
        setModal(null);
      }
    }

    document.addEventListener('click', clickOutsideModal);

    return () => {
      document.removeEventListener('click', clickOutsideModal);
    }
  }, []);

  useEffect(() => {
    const clickDropdownOutside = (e) => {
      if(dropdownRef.current && !dropdownRef.current.contains(e.target)){
        setActivMenu(null);
      }
    }
    document.addEventListener('click', clickDropdownOutside);
    return () => {
      document.removeEventListener('click', clickDropdownOutside);
    };
  }, []);

  const changeProfile = async (e) => {
    e.preventDefault();
    dispatch(setLoading(true));
    setErrors(null);
    setSuccessMessage(null);

    try {
      const dt = new FormData(e.target);
      const { data } = await axios.post(`${ endpointApi }profile`, dt, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${ jwt_access }`
        }
      });
      setSuccessMessage("Votre profil a été mis à jour.");
      dispatch(setMe(data));
    } catch (err) {
      if(err.response.status === 401){
        dispatch(logout(location.pathname + location.search, navigate));
      }else{
        setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
        const $modals = document.querySelectorAll('._modal-content');
        $modals.forEach($modal => {
          $modal.scrollTop = 0;
        });
      }
    }

    dispatch(setLoading(false));
  }

  const changeSettings = async(e) => {
    e.preventDefault();
    dispatch(setLoading(true));
    setErrors(null);
    setSuccessMessage(null);

    try {
      const dt = new FormData(e.target);
      const { data } = await axios.post(`${ endpointApi }account-settings`, dt, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${ jwt_access }`
        }
      });

      setSuccessMessage("Vos paramètres ont été mis à jour.");
      dispatch(setMe(data));
    } catch (err) {
      if(err.response.status === 401){
        dispatch(logout(location.pathname + location.search, navigate));
      }else{
        setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
        const $modals = document.querySelectorAll('._modal-content');
        $modals.forEach($modal => {
          $modal.scrollTop = 0;
        });
      }
    }

    dispatch(setLoading(false));
  }

  const closeSearch = () => {
    navigate(location.pathname);
  }

  return (
    <>
      <header id="header">
        <div className='d-flex align-items-center justify-content-between'>
          <form method='GET' className='search-form' onSubmit={ search }>
            <input type='text' name='q' value={ q } onChange={ (e) => setQ(e.target.value) } className='form-control' placeholder='Rechercher...' required autoComplete='off' />
            <button type='submit' className='submit-search'><i className='fa fa-search'></i></button>
            { _q && 
            <button type='button' className='close-search' onClick={ closeSearch }>&times;</button> }
          </form>
          <div className='auth'>
            <ul>
              <li ref={ dropdownRef } className={ `_dropdown${ activMenu === 1 ? ' active' : '' }` }>
                <button type='button' className='user-toggle-menu' onClick={ () => setActivMenu(activMenu === 1 ? null : 1) }>
                  <span><i className='fa fa-user'></i></span> <i className='fa fa-bars'></i>
                </button>
                <ul className='_dropdown-menu _dropdown-menu-right'>
                  <li><button type="button" onClick={ () => {
                    setModal("profile");
                    setActivMenu(null);
                  } }>Profil</button></li>
                  <li><button type="button" onClick={ () => {
                    setModal("settings");
                    setActivMenu(null);
                  } }>Paramètres</button></li>
                  <li><button type="button" onClick={ () => {
                    setActivMenu(null);
                    dispatch(logout(null, navigate));
                  }}>Déconnexion</button></li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </header>

      <div ref={ profileRef } className={ `_modal${ modal === 'profile' ? ' active' : '' }` }>
        <div className='_modal-content'>
          <div className='_modal-head'>
            <h4>Mon profil</h4>
            <button className='_modal-close'>&times;</button>
          </div>
          <div className='_modal-body'>
            { successMessage && <div className="alert alert-success">{ successMessage }</div> }
            <form className='form' onSubmit={ changeProfile }>
              { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
              <div className='pb-3'>
                <label htmlFor='gender' className='required'>Civilité</label>
                <select id='gender' name='gender' className='form-control' required value={ gender } onChange={ (e) => setGender(e.target.value) } onBlur={ () => setIsGenderTouched(true) }>
                  <option value="">Sélectionner...</option>
                  <option value="m">Monsieur</option>
                  <option value="f">Madame</option>
                </select>
                { isGenderTouched && gender.length === 0 && <div className='form-error'>Veuillez sélectionner la civilité.</div> }
                { errors && errors.gender && <div className='form-error'>{ errors.gender[0] }</div> }
              </div>
              <div className='row'>
                <div className='col-6 pb-3'>
                  <label htmlFor='last_name' className='required'>Nom</label>
                  <input type='text' id='last_name' name='last_name' placeholder='Nom' autoComplete='off' className='form-control' required value={ lastname } onChange={ (e) => setLastname(e.target.value) } onBlur={ () => setIsLastnameTouched(true) } />
                  { isLastnameTouched && lastname.length === 0 && <div className='form-error'>Veuillez saisir le nom.</div> }
                  { errors && errors.last_name && <div className='form-error'>{ errors.last_name[0] }</div> }
                </div>
                <div className='col-6 pb-3'>
                  <label htmlFor='first_name' className='required'>Prénom(s)</label>
                  <input type='text' id='first_name' name='first_name' placeholder='Prénom(s)' autoComplete='off' className='form-control' required value={ firstname } onChange={ (e) => setFirstname(e.target.value) } onBlur={ () => setIsFirstnameTouched(true) } />
                  { isFirstnameTouched && firstname.length === 0 && <div className='form-error'>Veuillez saisir le prénom.</div> }
                  { errors && errors.first_name && <div className='form-error'>{ errors.first_name[0] }</div> }
                </div>
              </div>
              <div className='pb-3'>
                <label htmlFor='job' className='required'>Fonction</label>
                <input type='text' id='job' name='job' placeholder='Fonction' autoComplete='off' className='form-control' required value={ job } onChange={ (e) => setJob(e.target.value) } onBlur={ () => setIsJobTouched(true) } />
                { isJobTouched && job.length > 0 && job.length < 2 && <div className='form-erorr'>La valeur de ce champ est trop courte. Veuillez saisir au moins 2 caractères.</div> }
                { errors && errors.job && <div className='form-error'>{ errors.job[0] }</div> }
              </div>
              <div className='pb-3'>
                <label htmlFor='phone'>Téléphone</label>
                <input type='text' id='phone' name='phone' placeholder='Téléphone' autoComplete='off' className='form-control' value={ phone } onChange={ (e) => setPhone(e.target.value) } onBlur={ () => setIsPhoneTouched(true) } />
                { isPhoneTouched && phone.length > 0 && /^(\+261|0)3[23478]\s?\d{2}\s?\d{3}\s?\d{2}$/.test(phone) === false && <div className='form-erorr'>Le numéro de téléphone n'est pas valide.</div> }
                { errors && errors.phone && <div className='form-error'>{ errors.phone[0] }</div> }
              </div>
              <div className='pt-2 text-end'>
                <button type='submit' className='btn btn-lg btn-primary' disabled={
                  gender.length === 0 || firstname.length === 0 || lastname.length === 0 || (job.length > 0 && job.length < 2) || (phone.length > 0 && /^(\+261|0)3[23478]\s?\d{2}\s?\d{3}\s?\d{2}$/.test(phone) === false) ||
                  (user && gender === user.gender && lastname === user.last_name && firstname === user.first_name && ((user.job === null && job.length === 0) || (user.job !== null && user.job === job)) && ((user.phone === null && phone.length === 0) || (user.phone !== null && user.phone === phone)))
                }><i className="fa fa-save"></i> Mettre à jour</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div ref={ settingsRef } className={ `_modal${ modal === 'settings' ? ' active' : '' }` }>
        <div className='_modal-content'>
          <div className='_modal-head'>
            <h4>Mes paramètres</h4>
            <button className='_modal-close'>&times;</button>
          </div>
          <div className='_modal-body'>
            { successMessage && <div className="alert alert-success">{ successMessage }</div> }
            <form className='form' onSubmit={ changeSettings }>
              { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
              <div className='pb-3'>
                <label htmlFor='current_password' className='required'>Actuel mot de passe (Laisser vide pour garder l'actuel)</label>
                <input type='password' id='current_password' name='current_password' required placeholder='Actuel mot de passe' className='form-control' value={ currentPassword } onChange={ (e) => setCurrentPassword(e.target.value) } onBlur={ () => setIsCurrentPasswordTouched(true) } />
                { isCurrentPasswordTouched && currentPassword.length === 0 && <div className='form-error'>Veuilliez saisir votre mot de passe.</div> }
                { errors && errors.current_password && <div className='form-error'>{ errors.current_password[0] }</div> }
              </div>
              <div className='pb-3'>
                <label htmlFor='email' className='required'>E-mail</label>
                <input type='email' id='email' name='email' placeholder='E-mail' autoComplete='off' className='form-control' required value={ email } onChange={ (e) => setEmail(e.target.value) } onBlur={ () => setIsEmailTouched(true) } />
                { isEmailTouched && email.length === 0 && <div className='form-error'>Veuillez saisir l'e-mail.</div> }
                { isEmailTouched && email.length > 0 && /^[a-z0-9.-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(email) === false && <div className='form-error'>L'e-mail n'est pas valide. Veuillez vérifier.</div> }
                { errors && errors.email && <div className='form-error'>{ errors.email[0] }</div> }
              </div>
              <div className='pb-3'>
                <label htmlFor='password'>Mot de passe (Laisser vide pour garder l'actuel)</label>
                <input type='password' id='password' name='password' placeholder='Mot de passe' className='form-control' value={ password } onChange={ (e) => setPassword(e.target.value) } onBlur={ () => setIsPasswordTouched(true) } />
                { isPasswordTouched && password.length > 0 && password.length < 8 && <div className='form-error'>Le mot de passe est trop court. Veuilliez saisir au moins 8 caractères.</div> }
                { errors && errors.password && <div className='form-error'>{ errors.password[0] }</div> }
              </div>
              <div className='pt-2 text-end'>
                <button type='submit' className='btn btn-lg btn-primary' disabled={
                  /^[a-z0-9.-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(email) === false || currentPassword.length === 0 || (password.length > 0 && password.length < 8) ||
                  (user && email === user.email)
                }><i className="fa fa-save"></i> Mettre à jour</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <footer id="footer">
        &copy; { date.getFullYear() } Société Mikalo. Créé par <a href="https://www.softlab.mg" rel="noreferrer" target='_blank'>Softlab</a>
      </footer>
    </>
  )
}
